import { FloatingChatButton } from './chat.styled';

interface ChatbotType {
  isChatModalOpen: boolean;
  openChatModal: () => void;
}

const Chatbot = ({ isChatModalOpen, openChatModal }: ChatbotType): JSX.Element => {
  return (
    <>
      {!isChatModalOpen && (
        <FloatingChatButton
          className='hidden sm:block'
          onClick={() => {
            openChatModal();
          }}>
          <span className='material-symbols-outlined minimize-icon-color'>chat_bubble</span>
        </FloatingChatButton>
      )}
    </>
  );
};

export default Chatbot;
